import React, { useContext } from 'react';
import { createPortal } from 'react-dom';

import Select from 'react-select';
import DatePicker from 'react-datepicker';
import $ from 'jquery';

import addDays from 'date-fns/addDays';
import format from 'date-fns/format';
import { EVENTS } from '../../utilities/CONSTANTS';
import { SuggestionsContext } from '../../context/SuggestionsContext';

const TOMORROW = addDays(new Date(), 1);

class SuggestPageUpdateModal extends React.Component {
    static contextType = SuggestionsContext;

    state = {
        value: '',
        users: null,
        selectedOption: null,
        isSaving: null,
        showSuccess: null,
        scheduledAt: null,
    };

    componentDidMount() {
        if (window._referencableTettraUsers) {
            return this.setUsers();
        }
        window.addEventListener(EVENTS.USERS_LOADED, this.setUsers);
    }

    componentWillUnmount() { return window.removeEventListener(EVENTS.USERS_LOADED, this.setUsers); }

    setUsers = () => {
        const authorId = this.props.page.user_id;
        const users = window._referencableTettraUsers
            .map(u => ({ value: u.id, label: u.display_name }))
            .filter(u => (u.value));
        const selectedOption = users.find(u => (u.value == authorId));

        return this.setState({ users, selectedOption });
    };

    handleSelectChange = (selectedOption) => {
        this.setState({ selectedOption });
    };

    updateShowSchedule = () => {
        if (this.state.scheduledAt) {
            this.setState({ scheduledAt: null });
        } else {
            this.setState({ scheduledAt: TOMORROW });
        }
    };

    getFormattedSuggestion = (id) => {
        const { selectedOption: { value: assignable_id }, value: description } = this.state;
        const assignable = window._referencableTettraUsers.find(u => (u.id === assignable_id));
        const requester = window._referencableTettraUsers.find(u => (u.id === window.userId));
        const created_at = (new Date()).toISOString();

        return {
            id, assignable, requester, description, created_at,
        };
    };

    createSuggestion = () => {
        const update = true;
        const page_id = this.props.page.id;
        const {
            selectedOption: { value: assignable_id }, value: description, isSaving, showSuccess,
        } = this.state;
        const schedule_at = this.state.scheduledAt ? format(this.state.scheduledAt, 'MM/dd/yyyy') : null;
        if (isSaving || showSuccess) return;
        this.setState({ isSaving: true });
        const _token = window.csrfToken;

        return $.post(`/api/teams/${window.teamId}/suggestions`, {
            page_id, update, assignable_id, description, schedule_at, _token,
        })
            .then(({ success, suggestionId }) => {
                this.setState({ isSaving: false, showSuccess: true });
                setTimeout(() => this.props.closeModal(), 1000);
                if (this.context && suggestionId) {
                    const { setSuggestions } = this.context;
                    $.get(`/api/teams/${window.teamId}/pages/${this.props.page.id}/suggestions`)
                        .done(({ suggestions }) => {
                            if (suggestions) {
                                setSuggestions(suggestions);
                            }
                        }).catch(console.error);
                }
            }).catch(console.error);
    };

    onClickModal = ({ target }) => {
        const className = target.getAttribute('class');
        if (this.props.closeModal && className && className.includes('react-modal open')) {
            this.props.closeModal();
        }
    };

    render() {
        const {
            value, users, selectedOption, isSaving, showSuccess, scheduledAt,
        } = this.state;
        const btnClass = !isSaving ? 'btn btn-primary' : 'btn btn-primary is-disabled';
        const btnText = !isSaving ? 'Create request' : 'Saving...';

        return (
            <div className="react-modal open suggest-update-modal" onMouseDown={this.onClickModal}>
                <div className="modal-content p2">
                    {showSuccess && <div className="modal-notification mxn2 myn2 rounded-top">Update requested!</div>}
                    <h2>Request an update</h2>
                    <textarea
                        placeholder="What should be updated?"
                        rows="3"
                        className="block col-12 field"
                        cols="50"
                        value={value}
                        onChange={({ target: { value } }) => this.setState({ value })}
                    />
                    <label className="bold block col-12 mb1 mt2">Who should update this page?</label>
                    {
                        !users
                            ? <span className="gray loading">Loading users</span>
                            : (
                                <Select
                                    value={selectedOption}
                                    onChange={this.handleSelectChange}
                                    options={users}
                                />
                            )

                    }
                    <div className="mb2">
                        <label htmlFor="schedule_at" className="bold block col-12 mb1 mt2">When should we send this request?</label>
                        <label>
                            <input type="radio" value="Now" checked={!scheduledAt} onChange={this.updateShowSchedule} />
                            {' '}
Now
                        </label>
                        <br />
                        <label className="mb3">
                            <input type="radio" value="On" checked={!!scheduledAt} onChange={this.updateShowSchedule} />
                            {' '}
Send on:
                            <DatePicker
                                id="schedule_at"
                                name="schedule_at"
                                className="block field ml1"
                                minDate={TOMORROW}
                                onChange={scheduledAt => this.setState({ scheduledAt })}
                                selected={this.state.scheduledAt}
                                disabled={!scheduledAt}
                            />
                        </label>
                    </div>
                    <div className="right-align mt3">
                        <span className="btn-secondary mr1" onClick={this.props.closeModal}>Cancel</span>
                        <span className={btnClass} onMouseDown={this.createSuggestion}>{btnText}</span>
                    </div>
                </div>
            </div>
        );
    }
}

export default (props) => createPortal(<SuggestPageUpdateModal {...props} />, document.body);
